import { render, staticRenderFns } from "./PositionOffersReport.vue?vue&type=template&id=70461ad0"
import script from "./PositionOffersReport.vue?vue&type=script&lang=js"
export * from "./PositionOffersReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports